import { Component, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import * as XLSX from 'xlsx-js-style';

@Component({
  selector: 'nc-excel-viewer',
  templateUrl: './excel-viewer.component.html',
  styleUrls: ['./excel-viewer.component.less']
})
export class ExcelViewerComponent implements OnChanges {
  /** excel文件地址 */
  @Input() ncUrl: string = '';
  /** 是否显示工作表名称 */
  private _sheetName: boolean = false;
  @Input() set ncSheetName(value: boolean | string) {
    this._sheetName = value !== null && value !== undefined && value !== false && value !== 'false';
  }
  get ncSheetName(): boolean {
    return this._sheetName;
  }

  constructor(private eleRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['ncUrl']) {
      this.renderExcelDocument();
    }
  }

  async renderExcelDocument() {
    const response = await fetch(this.ncUrl);
    const blob = await response.blob();
    const reader = new FileReader();
    //通过readAsArrayBuffer将blob转换为ArrayBuffer对
    reader.readAsArrayBuffer(blob);
    reader.onload = (event) => {
      // 读取ArrayBuffer数据变成Uint8Array
      const data = new Uint8Array(event.target?.result as ArrayBuffer);
      // 这里的data里面的类型和后面的type类型要对应
      const workbook = XLSX.read(data, { type: "array" });
      const sheetNames = workbook.SheetNames; // 工作表名称
      let htmlArray = [];
      for (let i = 0; i < sheetNames.length; i++) {
        // var excelData = XLSX.utils.sheet_to_json(worksheet); //JSON
        const worksheet = workbook.Sheets[sheetNames[i]];
        if (this.ncSheetName) {
          htmlArray.push(`<h2>${sheetNames[i]}</h2>`);
        }
        htmlArray.push(XLSX.utils.sheet_to_html(worksheet));
      }
      const container = this.eleRef.nativeElement.querySelector('#excel-container');
      container.innerHTML = htmlArray.join('');
    };
  }

}
